var map = {
	"./square/ac.svg": 1764,
	"./square/ad.svg": 1765,
	"./square/ae.svg": 1766,
	"./square/af.svg": 1767,
	"./square/ag.svg": 1768,
	"./square/ai.svg": 1769,
	"./square/al.svg": 1770,
	"./square/am.svg": 1771,
	"./square/ao.svg": 1772,
	"./square/aq.svg": 1773,
	"./square/ar.svg": 1774,
	"./square/as.svg": 1775,
	"./square/at.svg": 1776,
	"./square/au.svg": 1777,
	"./square/aw.svg": 1778,
	"./square/ax.svg": 1779,
	"./square/az.svg": 1780,
	"./square/ba.svg": 1781,
	"./square/bb.svg": 1782,
	"./square/bd.svg": 1783,
	"./square/be.svg": 1784,
	"./square/bf.svg": 1785,
	"./square/bg.svg": 1786,
	"./square/bh.svg": 1787,
	"./square/bi.svg": 1788,
	"./square/bj.svg": 1789,
	"./square/bl.svg": 1790,
	"./square/bm.svg": 1791,
	"./square/bn.svg": 1792,
	"./square/bo.svg": 1793,
	"./square/bq.svg": 1794,
	"./square/br.svg": 1795,
	"./square/bs.svg": 1796,
	"./square/bt.svg": 1797,
	"./square/bv.svg": 1798,
	"./square/bw.svg": 1799,
	"./square/by.svg": 1800,
	"./square/bz.svg": 1801,
	"./square/ca.svg": 1802,
	"./square/cc.svg": 1803,
	"./square/cd.svg": 1804,
	"./square/cefta.svg": 1805,
	"./square/cf.svg": 1806,
	"./square/cg.svg": 1807,
	"./square/ch.svg": 1808,
	"./square/ci.svg": 1809,
	"./square/ck.svg": 1810,
	"./square/cl.svg": 1811,
	"./square/cm.svg": 1812,
	"./square/cn.svg": 1813,
	"./square/co.svg": 1814,
	"./square/cp.svg": 1815,
	"./square/cr.svg": 1816,
	"./square/cu.svg": 1817,
	"./square/cv.svg": 1818,
	"./square/cw.svg": 1819,
	"./square/cx.svg": 1820,
	"./square/cy.svg": 1821,
	"./square/cz.svg": 1822,
	"./square/de.svg": 1823,
	"./square/dg.svg": 1824,
	"./square/dj.svg": 1825,
	"./square/dk.svg": 1826,
	"./square/dm.svg": 1827,
	"./square/do.svg": 1828,
	"./square/dz.svg": 1829,
	"./square/ea.svg": 1830,
	"./square/ec.svg": 1831,
	"./square/ee.svg": 1832,
	"./square/eg.svg": 1833,
	"./square/eh.svg": 1834,
	"./square/er.svg": 1835,
	"./square/es-ct.svg": 1836,
	"./square/es-ga.svg": 1837,
	"./square/es.svg": 1838,
	"./square/et.svg": 1839,
	"./square/eu.svg": 1840,
	"./square/fi.svg": 1841,
	"./square/fj.svg": 1842,
	"./square/fk.svg": 1843,
	"./square/fm.svg": 1844,
	"./square/fo.svg": 1845,
	"./square/fr.svg": 1846,
	"./square/ga.svg": 1847,
	"./square/gb-eng.svg": 1848,
	"./square/gb-nir.svg": 1849,
	"./square/gb-sct.svg": 1850,
	"./square/gb-wls.svg": 1851,
	"./square/gb.svg": 1852,
	"./square/gd.svg": 1853,
	"./square/ge.svg": 1854,
	"./square/gf.svg": 1855,
	"./square/gg.svg": 1856,
	"./square/gh.svg": 1857,
	"./square/gi.svg": 1858,
	"./square/gl.svg": 1859,
	"./square/gm.svg": 1860,
	"./square/gn.svg": 1861,
	"./square/gp.svg": 1862,
	"./square/gq.svg": 1863,
	"./square/gr.svg": 1864,
	"./square/gs.svg": 1865,
	"./square/gt.svg": 1866,
	"./square/gu.svg": 1867,
	"./square/gw.svg": 1868,
	"./square/gy.svg": 1869,
	"./square/hk.svg": 1870,
	"./square/hm.svg": 1871,
	"./square/hn.svg": 1872,
	"./square/hr.svg": 1873,
	"./square/ht.svg": 1874,
	"./square/hu.svg": 1875,
	"./square/ic.svg": 1876,
	"./square/id.svg": 1877,
	"./square/ie.svg": 1878,
	"./square/il.svg": 1879,
	"./square/im.svg": 1880,
	"./square/in.svg": 1881,
	"./square/io.svg": 1882,
	"./square/iq.svg": 1883,
	"./square/ir.svg": 1884,
	"./square/is.svg": 1885,
	"./square/it.svg": 1886,
	"./square/je.svg": 1887,
	"./square/jm.svg": 1888,
	"./square/jo.svg": 1889,
	"./square/jp.svg": 1890,
	"./square/ke.svg": 1891,
	"./square/kg.svg": 1892,
	"./square/kh.svg": 1893,
	"./square/ki.svg": 1894,
	"./square/km.svg": 1895,
	"./square/kn.svg": 1896,
	"./square/kp.svg": 1897,
	"./square/kr.svg": 1898,
	"./square/kw.svg": 1899,
	"./square/ky.svg": 1900,
	"./square/kz.svg": 1901,
	"./square/la.svg": 1902,
	"./square/lb.svg": 1903,
	"./square/lc.svg": 1904,
	"./square/li.svg": 1905,
	"./square/lk.svg": 1906,
	"./square/lr.svg": 1907,
	"./square/ls.svg": 1908,
	"./square/lt.svg": 1909,
	"./square/lu.svg": 1910,
	"./square/lv.svg": 1911,
	"./square/ly.svg": 1912,
	"./square/ma.svg": 1913,
	"./square/mc.svg": 1914,
	"./square/md.svg": 1915,
	"./square/me.svg": 1916,
	"./square/mf.svg": 1917,
	"./square/mg.svg": 1918,
	"./square/mh.svg": 1919,
	"./square/mk.svg": 1920,
	"./square/ml.svg": 1921,
	"./square/mm.svg": 1922,
	"./square/mn.svg": 1923,
	"./square/mo.svg": 1924,
	"./square/mp.svg": 1925,
	"./square/mq.svg": 1926,
	"./square/mr.svg": 1927,
	"./square/ms.svg": 1928,
	"./square/mt.svg": 1929,
	"./square/mu.svg": 1930,
	"./square/mv.svg": 1931,
	"./square/mw.svg": 1932,
	"./square/mx.svg": 1933,
	"./square/my.svg": 1934,
	"./square/mz.svg": 1935,
	"./square/na.svg": 1936,
	"./square/nc.svg": 1937,
	"./square/ne.svg": 1938,
	"./square/nf.svg": 1939,
	"./square/ng.svg": 1940,
	"./square/ni.svg": 1941,
	"./square/nl.svg": 1942,
	"./square/no.svg": 1943,
	"./square/np.svg": 1944,
	"./square/nr.svg": 1945,
	"./square/nu.svg": 1946,
	"./square/nz.svg": 1947,
	"./square/om.svg": 1948,
	"./square/pa.svg": 1949,
	"./square/pe.svg": 1950,
	"./square/pf.svg": 1951,
	"./square/pg.svg": 1952,
	"./square/ph.svg": 1953,
	"./square/pk.svg": 1954,
	"./square/pl.svg": 1955,
	"./square/pm.svg": 1956,
	"./square/pn.svg": 1957,
	"./square/pr.svg": 1958,
	"./square/ps.svg": 1959,
	"./square/pt.svg": 1960,
	"./square/pw.svg": 1961,
	"./square/py.svg": 1962,
	"./square/qa.svg": 1963,
	"./square/re.svg": 1964,
	"./square/ro.svg": 1965,
	"./square/rs.svg": 1966,
	"./square/ru.svg": 1967,
	"./square/rw.svg": 1968,
	"./square/sa.svg": 1969,
	"./square/sb.svg": 1970,
	"./square/sc.svg": 1971,
	"./square/sd.svg": 1972,
	"./square/se.svg": 1973,
	"./square/sg.svg": 1974,
	"./square/sh.svg": 1975,
	"./square/si.svg": 1976,
	"./square/sj.svg": 1977,
	"./square/sk.svg": 1978,
	"./square/sl.svg": 1979,
	"./square/sm.svg": 1980,
	"./square/sn.svg": 1981,
	"./square/so.svg": 1982,
	"./square/sr.svg": 1983,
	"./square/ss.svg": 1984,
	"./square/st.svg": 1985,
	"./square/sv.svg": 1986,
	"./square/sx.svg": 1987,
	"./square/sy.svg": 1988,
	"./square/sz.svg": 1989,
	"./square/ta.svg": 1990,
	"./square/tc.svg": 1991,
	"./square/td.svg": 1992,
	"./square/tf.svg": 1993,
	"./square/tg.svg": 1994,
	"./square/th.svg": 1995,
	"./square/tj.svg": 1996,
	"./square/tk.svg": 1997,
	"./square/tl.svg": 1998,
	"./square/tm.svg": 1999,
	"./square/tn.svg": 2000,
	"./square/to.svg": 2001,
	"./square/tr.svg": 2002,
	"./square/tt.svg": 2003,
	"./square/tv.svg": 2004,
	"./square/tw.svg": 2005,
	"./square/tz.svg": 2006,
	"./square/ua.svg": 2007,
	"./square/ug.svg": 2008,
	"./square/um.svg": 2009,
	"./square/un.svg": 2010,
	"./square/us.svg": 2011,
	"./square/uy.svg": 2012,
	"./square/uz.svg": 2013,
	"./square/va.svg": 2014,
	"./square/vc.svg": 2015,
	"./square/ve.svg": 2016,
	"./square/vg.svg": 2017,
	"./square/vi.svg": 2018,
	"./square/vn.svg": 2019,
	"./square/vu.svg": 2020,
	"./square/wf.svg": 2021,
	"./square/ws.svg": 2022,
	"./square/xk.svg": 2023,
	"./square/xx.svg": 2024,
	"./square/ye.svg": 2025,
	"./square/yt.svg": 2026,
	"./square/za.svg": 2027,
	"./square/zm.svg": 2028,
	"./square/zw.svg": 2029
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1763;